import HowItWorksModal from './HowItWorksModal';

export default HowItWorksModal;
